"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _is = require("@utiljs/is");

var _Popper = require("../core/Popper");

var _Trigger = _interopRequireDefault(require("./Trigger"));

var _Popup = _interopRequireDefault(require("./Popup"));

var _utils = require("../_utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Tooltip = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    (0, _classCallCheck2.default)(this, Tooltip);
    _this = _super.apply(this, arguments);
    _this.state = {
      visible: false
    };

    _this.toggleVisible = function (v) {
      var _this$props = _this.props,
          manual = _this$props.manual,
          onVisibleChange = _this$props.onVisibleChange; // 历史问题，以 manual 作为受控模式

      if (manual) {
        if ((0, _is.isFunction)(onVisibleChange)) {
          var t = _this.state.visible;
          onVisibleChange(v !== undefined ? v : !t);
        }

        return;
      }

      _this.setState(function (state) {
        return {
          visible: v !== undefined ? v : !state.visible
        };
      }, function () {
        (0, _utils.executeFoo)(onVisibleChange)(_this.state.visible);
      });
    };

    _this.handleClickOutside = function (e) {
      var _this$props2 = _this.props,
          trigger = _this$props2.trigger,
          visible = _this$props2.visible;
      console.log('kanwo time', visible, _this.state.visible);

      if (trigger === 'click' && _this.state.visible && e.target !== _this.target) {
        console.log('its time to execute', visible);

        _this.toggleVisible(false);
      }
    };

    _this.firePropsEvent = function (eventName, event) {
      var childProps = _this.props.children.props;

      if (childProps[eventName] && !childProps.disabled && !childProps.readOnly) {
        childProps[eventName](event);
      }
    };

    _this.handleClick = function (e) {
      var trigger = _this.props.trigger;

      if (trigger === 'click') {
        _this.target = e.target;

        _this.toggleVisible();
      }

      _this.firePropsEvent('onClick', e);
    };

    _this.handleMouseEnter = function (e) {
      var trigger = _this.props.trigger;

      if (trigger === 'hover') {
        _this.toggleVisible(true);
      }

      _this.firePropsEvent('onMouseEnter', e);
    };

    _this.handlePopupMouseEnter = function (e) {
      var _this$props3 = _this.props,
          trigger = _this$props3.trigger,
          enterable = _this$props3.enterable;

      if (!enterable) {
        return;
      }

      if (trigger === 'hover') {
        _this.toggleVisible(true);
      }

      _this.firePropsEvent('onMouseEnter', e);
    };

    _this.handleMouseLeave = function (e) {
      var trigger = _this.props.trigger;

      if (trigger === 'hover') {
        _this.toggleVisible(false);
      }

      _this.firePropsEvent('onMouseLeave', e);
    };

    _this.handlePopupMouseLeave = function (e) {
      var _this$props4 = _this.props,
          trigger = _this$props4.trigger,
          enterable = _this$props4.enterable;

      if (!enterable) {
        return;
      }

      if (trigger === 'hover') {
        _this.toggleVisible(false);
      }

      _this.firePropsEvent('onMouseLeave', e);
    };

    _this.handleFocus = function (e) {
      var trigger = _this.props.trigger;

      if (trigger === 'focus') {
        _this.toggleVisible(true);
      }

      _this.firePropsEvent('onFocus', e);
    };

    _this.handleBlur = function (e) {
      var trigger = _this.props.trigger;

      if (trigger === 'focus') {
        _this.toggleVisible(false);
      }

      _this.firePropsEvent('onBlur', e);
    };

    _this.getPlacement = function (placement) {
      return placement.replace('Left', '-start').replace('Right', '-end').replace('Top', '-start').replace('Bottom', '-end');
    };

    return _this;
  }

  (0, _createClass2.default)(Tooltip, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var visible = this.state.visible;
      var _this$props5 = this.props,
          effect = _this$props5.effect,
          content = _this$props5.content,
          popupClassName = _this$props5.popupClassName,
          className = _this$props5.className,
          style = _this$props5.style,
          position = _this$props5.placement,
          children = _this$props5.children,
          popupContainer = _this$props5.popupContainer,
          disabled = _this$props5.disabled,
          flip = _this$props5.flip;

      if (disabled) {
        return children;
      }

      return /*#__PURE__*/React.createElement(_Popper.Manager, null, /*#__PURE__*/React.createElement(_Popper.Reference, null, function (_ref) {
        var ref = _ref.ref;
        return /*#__PURE__*/React.createElement(_Trigger.default, {
          innerRef: ref,
          onMouseEnter: _this2.handleMouseEnter,
          onMouseLeave: _this2.handleMouseLeave,
          onFocus: _this2.handleFocus,
          onBlur: _this2.handleBlur,
          onClick: _this2.handleClick,
          className: className,
          style: style
        }, children);
      }), /*#__PURE__*/React.createElement(_Popper.PopperPortal, {
        visible: visible,
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          hide: {
            enabled: false
          },
          offset: {
            enabled: false
          },
          flip: {
            enabled: flip,
            flipVariationsByContent: flip === 'flip'
          }
        },
        container: popupContainer,
        placement: this.getPlacement(position),
        onClickOutside: this.handleClickOutside
      }, function (_ref2) {
        var placement = _ref2.placement,
            ref = _ref2.ref;
        return /*#__PURE__*/React.createElement(_Popup.default, {
          innerRef: ref,
          effect: effect,
          placement: placement,
          content: content,
          popupClassName: popupClassName,
          onMouseEnter: _this2.handlePopupMouseEnter,
          onMouseLeave: _this2.handlePopupMouseLeave
        });
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.manual) {
        return {
          visible: nextProps.visible
        };
      }

      return null;
    }
  }]);
  return Tooltip;
}(React.Component);

Tooltip.propTypes = {
  effect: PropTypes.oneOf(['light', 'dark']),
  content: PropTypes.any,
  trigger: PropTypes.oneOf(['hover', 'click', 'focus']),
  placement: PropTypes.oneOf(['top', 'topLeft', 'topRight', 'right', 'rightTop', 'rightBottom', 'bottom', 'bottomLeft', 'bottomRight', 'left', 'leftTop', 'leftBottom']),
  visible: PropTypes.bool,
  manual: PropTypes.bool,
  enterable: PropTypes.bool,
  disabled: PropTypes.bool,
  flip: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  popupContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func]),
  className: PropTypes.string,
  onVisibleChange: PropTypes.func
};
Tooltip.defaultProps = {
  effect: 'dark',
  content: '',
  trigger: 'hover',
  placement: 'top',
  visible: false,
  manual: false,
  enterable: true,
  disabled: false,
  flip: true,
  popupContainer: document.body,
  className: '',
  onVisibleChange: undefined
};
var _default = Tooltip;
exports.default = _default;